export enum ServiceStatus {
    NoInfo = 'noInfo',
    Processing = 'processing',
    Processed = 'processed',
    LeaverNotified = 'leaverNotified',
}
